import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export const MetricsSkeleton = () => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="border-border shadow-sm bg-card">
            <CardContent className="pt-6">
              <div className="flex justify-between mb-2">
                <Skeleton className="h-5 w-5 rounded bg-muted" />
              </div>
              <Skeleton className="h-8 w-16 mb-2 bg-muted" />
              <Skeleton className="h-4 w-24 bg-muted" />
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Bottom Grid Skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-8">
        {/* Ticket Status Skeleton */}
        <Card className="lg:col-span-2 border-border shadow-sm">
          <CardHeader>
            <Skeleton className="h-6 w-32 bg-muted" />
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-4">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="space-y-2">
                  <div className="flex justify-between">
                    <Skeleton className="h-4 w-24 bg-muted" />
                    <Skeleton className="h-4 w-8 bg-muted" />
                  </div>
                  <Skeleton className="h-2 w-full rounded-full bg-muted" />
                </div>
              ))}
            </div>

            <div className="pt-4 border-t border-border">
              <Skeleton className="h-4 w-40 mb-4 bg-muted" />
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                {[1, 2, 3, 4].map((i) => (
                  <Skeleton
                    key={i}
                    className="h-20 w-full rounded-lg bg-muted"
                  />
                ))}
              </div>
            </div>
          </CardContent>
        </Card>

        {/* Crew Skeleton */}
        <Card className="border-border shadow-sm">
          <CardHeader>
            <Skeleton className="h-6 w-32 bg-muted" />
          </CardHeader>
          <CardContent className="space-y-8">
            <div className="flex flex-col items-center">
              <Skeleton className="h-12 w-16 mb-2 bg-muted" />
              <Skeleton className="h-4 w-24 bg-muted" />
            </div>
            <div className="space-y-2">
              <div className="flex justify-between">
                <Skeleton className="h-4 w-20 bg-muted" />
                <Skeleton className="h-4 w-10 bg-muted" />
              </div>
              <Skeleton className="h-2 w-full bg-muted" />
            </div>
            <div className="grid grid-cols-2 gap-4">
              <Skeleton className="h-24 rounded-lg bg-muted" />
              <Skeleton className="h-24 rounded-lg bg-muted" />
            </div>
          </CardContent>
        </Card>
      </div>
    </>
  );
};
